import React from "react";
import { useT } from "@/i18n";
import { PRESETS, presetToRange } from "@/lib/charts";
import { cn } from "@/lib/utils";

/**
 * Interruptor de instrumento: un contenedor con borde hairline y
 * divisiones internas, el activo con fondo tinta y texto papel. Sin
 * píldoras separadas.
 */
export const PeriodFilter = ({ value, onChange, testId = "period-filter" }) => {
  const { t } = useT();
  const preset = value?.preset || "this_month";

  const choose = (p) => {
    if (p === "custom") {
      onChange({ preset: p, desde: value?.desde, hasta: value?.hasta });
      return;
    }
    onChange({ preset: p, ...presetToRange(p) });
  };

  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-3">
      <div className="flex divide-x divide-line border border-line">
        {PRESETS.map((p) => (
          <button
            key={p}
            data-testid={`${testId}-${p}`}
            onClick={() => choose(p)}
            className={cn(
              "px-3 py-1.5 text-[12px] font-medium transition-colors duration-[120ms]",
              preset === p ? "bg-ink text-paper" : "bg-paper text-ink-secondary hover:text-ink"
            )}
          >
            {t(`period.${p}`)}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div className="flex items-center gap-1.5">
          <input
            type="date"
            data-testid={`${testId}-from`}
            value={value?.desde || ""}
            onChange={(e) => onChange({ ...value, preset: "custom", desde: e.target.value })}
            className="h-8 rounded-control border border-line bg-paper px-2 font-mono text-[12px] text-ink"
          />
          <span className="text-[12px] text-ink-tertiary">{t("period.to")}</span>
          <input
            type="date"
            data-testid={`${testId}-to`}
            value={value?.hasta || ""}
            onChange={(e) => onChange({ ...value, preset: "custom", hasta: e.target.value })}
            className="h-8 rounded-control border border-line bg-paper px-2 font-mono text-[12px] text-ink"
          />
        </div>
      )}
    </div>
  );
};
